import React, {Component} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faChevronDown} from '@fortawesome/free-solid-svg-icons'

import {Avatar} from '../styled/Avatar/Avatar'
import {SectionHomePage} from '../styled/SectionHomePage/SectionHomePage'

import {shortInfo} from '../constants/data'

class HomeBackground extends Component {
    onClick = () => {
        document.getElementById('about-me').scrollIntoView()
    }

    render() {
        return (
            <div className="fullscreen">
                <SectionHomePage image={shortInfo.cover}>
                    <div className="overlay">
                        <div className="container text-center">
                            <div className="position-middle">
                                <Avatar className="margin-bottom-30" src={shortInfo.avatar}/>
                                <h1 className="title-name">{shortInfo.name}</h1>
                                <p className="sub-title">
                                    {shortInfo.major}
                                </p>
                            </div>
                            <div className="position-bottom">
                                <div className="icon">
                                    <div className="un-select" onClick={this.onClick}>
                                        <FontAwesomeIcon
                                            size={"lg"}
                                            icon={faChevronDown}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SectionHomePage>
            </div>
        )
    }
}

export default HomeBackground